import React, { Component } from 'react'
import './index.less'
import { List, Toast } from 'antd-mobile'
import StoreInfo from '../order-detail/components/store-info/index'
import LookCodeCell from './components/lookcode-cell'
import LookCodeInfo from './components/lookcode-info'
import { fetchLookCode } from '../../api/look-code'
import { setHeader } from '@/util/set-header'
import { getAuth } from '../../util/storage';

export default class LookCode extends Component<any,any>{
  state: any = {
    baseModel: {},
  }

  UNSAFE_componentWillMount() {
    setHeader({ title: '提货码' })
  }

  async componentDidMount() {
    let order_sn = this.props.location.state.order_sn
    let auth = getAuth()    
    let params = {
      order_sn: order_sn,
      auth: auth,
    }
    let data = await fetchLookCode(params)
    
    if (data.data) {
      this.setState({ baseModel: data.data })
    } else {
      Toast.info("服务器返回格式错误",1)
    }
  }

  _storeInfoItem() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS') {
      if (baseModel.data.depot) {
        const depot = baseModel.data.depot
        return (
          <StoreInfo
            store={depot.name}
            tel={depot.contact_way}
            address={depot.address}
          />
        )
      }
    }
    return null
  }

  _qcodeItem() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS') {
      return (
        <LookCodeCell
          qcode_url={baseModel.data.qcode_url}
          pwd={baseModel.data.password}
        />
      )
    }
    return null
  }

  _infoItem() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS') {
      return <LookCodeInfo tips={baseModel.data.info} />
    }
    return null
  }

  render() {
    return (
      <div>
        <div className="nav-space" />
        <List>
          {this._storeInfoItem()}
          {this._qcodeItem()}
          {this._infoItem()}
        </List>
      </div>
    )
  }
}
